import { LockKeyhole, Moon, Sun } from 'lucide-react';
import { Button } from '@ampm-7en-ai/ui/components/Button';
import { Panel } from '@ampm-7en-ai/ui/components/Panel';
import LoginForm from '@/components/auth/LoginForm';
import { useAuth } from '@/context/AuthContext';
import { useAppTheme } from '@/hooks/useAppTheme';

const Login = () => {
  const { setPendingVerificationEmail } = useAuth();
  const { theme, toggleTheme } = useAppTheme();

  return (
    <div className="flex min-h-screen flex-col bg-ui-canvas font-ui text-ui-fg antialiased">
      <header className="flex items-center justify-between gap-4 px-5 py-5 sm:px-8">
        <div className="flex min-w-0 items-center gap-4">
          <img src={theme === 'dark' ? '/logo-white-new.svg' : '/logo-new.svg'} alt="7en" className="h-6 w-auto" />
          <span className="border-l border-ui-border pl-4 text-ui-sm font-medium text-ui-fg-muted">Superadmin</span>
        </div>
        <Button
          variant="ghost"
          size="icon"
          aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          onClick={toggleTheme}
        >
          {theme === 'dark' ? <Sun aria-hidden /> : <Moon aria-hidden />}
        </Button>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-8 sm:py-12">
        <div className="w-full max-w-[440px]">
          <Panel as="section" padding="none" aria-label="Superadmin sign in" className="p-6 shadow-card sm:p-8">
            <LoginForm onOtpVerificationNeeded={setPendingVerificationEmail} />
            <div className="mt-6 flex items-start gap-2 border-t border-ui-border pt-5 text-ui-xs text-ui-fg-muted">
              <LockKeyhole className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
              <p>Restricted to authorized platform administrators.</p>
            </div>
          </Panel>
          <p className="mt-6 text-center text-ui-xs text-ui-fg-muted">
            Need help?{' '}
            <a
              href="https://docs.7en.ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-sm font-medium text-ui-fg underline underline-offset-4 hover:text-ui-accent-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring"
            >
              View documentation<span className="sr-only"> (opens in a new tab)</span>
            </a>
          </p>
        </div>
      </main>
      <footer className="px-5 pb-5 text-center text-ui-xs text-ui-fg-subtle">7en platform administration</footer>
    </div>
  );
};

export default Login;
